export default {
	LOCALE: "locale",
	CONTRAST: "contrast_version"
}